export const toggleClass = (
  condition: boolean,
  el: HTMLElement,
  className: string
) => {
  if (condition) el.classList.add(className)
  else el.classList.remove(className)
}

export const waitForElement = async (selector: string, timeoutMs: number) => {
  const intervalMs = 25
  let startTime = timeoutMs
  while (!document.querySelector(selector) && startTime > 0) {
    startTime -= intervalMs
    await new Promise((resolve) => setTimeout(resolve, intervalMs))
  }

  return document.querySelector(selector)
}

export const sanitise = (input: string, maxLength = 16) =>
  input
    .trim()
    .slice(0, maxLength)
    .replace(/[^A-Za-z0-9_-]/g, "_")

export const getRootDomain = (hostname: string) => {
  const doubleTlds = ["co", "com"]
  let parts = hostname.split(".")
  if (parts.length <= 2) return hostname
  parts = parts.slice(-3)
  if (doubleTlds.indexOf(parts[1]) > -1) return parts.join(".")

  return parts.slice(-2).join(".")
}
